//s_account is localized and defined in s_code.js which is available in global scope
$(function() {
  'use strict';
  var initChat =  function() {  
  	var browser = window.navigator.userAgent;
  	//chat not supported in MS IE
  	if(browser.indexOf('MSIE ') > 0 || browser.indexOf('Trident/') > 0 || browser.indexOf('iPhone') > 0 || browser.indexOf('Android ') > 0){
  		return false;
  	};
  	
  	
	$.when(moduleEvents().GetChatCSSBundle()).done(function(data){
    	   var chatWrapper = document.getElementById('chat-wrapper');
    	   $(chatWrapper).append(createChatFrame());
    	   //must get latest chat bundle from server
    	   $.when(moduleEvents().InitChat()).done(function(result){	
         	$('#chat-iframe > body').append(result);
         	window.setTimeout(function(){
         		var iframe = document.getElementsByTagName('iframe');
         		if(iframe.length > 0){
	   		  iframe[0].contentWindow.postMessage(data, '*');
	   		  $.when(moduleEvents().IsOfficeOpen()).done(function(result){
		  	    if (result.OfficeOpen) {
			      var chatIcon = document.getElementsByClassName('openChat');
			      if(chatIcon.length > 0){
			        chatIcon[0].classList.remove('hide');
			        chatIcon[0].classList.add('show');
			       }
		          }
		      });
	   	    }
	   	}, 4000);
         });
	});
  };
  
  //Listen to messages from chat window
  window.addEventListener('message', function(e) {
    var key = e.message ? "message" : "data";
    var data = e[key];
    if(e.data == 'closeChatWindow') {
    	$('#chat-wrapper').toggle('slow');
    	var openChat = document.getElementsByClassName('openChat')[0];
    	openChat.classList.remove('bkgdLtGray', 'disabled');
    	openChat.classList.add('bkgdMdGray');
    	openChat.focus();
    	$('.openChat').after('<span class="visually-hidden" aria-live="polite">Your chat session has ended.</span>');
    }
  }, false);  
  	
  //Initialize Email Tab
  //Click handler
  document.getElementsByClassName('openEmail')[0].addEventListener('click', function(e){
   	if($(this).hasClass('disabled')) return false;
       $(this).after('<div class="spinner" role="alert" aria-busy="true" aria-label="Loading, please wait"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>');
	$.when(moduleEvents().GetEmailForm()).done(function(result){
		$('.contactPanel').append(result);
		$('.contactPanel').find('.spinner').detach();
		$('#emailPopout').toggle('slow');
		$('.openEmail').removeClass('bkgdMdGray').addClass('bkgdLtGray disabled');
		$('#email').focus();
	});
  });
  //Keypress handler	
  document.getElementsByClassName('openEmail')[0].addEventListener('keypress', function(e){
	if(e.which == 13){
 		this.click();
	 }
  });
	
 //Submit Email
  $('body').on('click touch', '.submitEmail', function () {
	var filter = /^([\w-&+\']+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,66}(?:\.[a-z]{2})?)$/i;
	var email = $('#email').val();
	var catAlias = $('#CatalogAlias').val();
	var questions = $('#questions').val().trim();
	var triggerElement = $(this);
	$('.ErrorMsgPanel > ul').html('');
	$('.emailSent').remove();
	var isFormValid = true;
	if (email !== "" && !filter.test(email)) {
		$('#email').css("backgroundColor", '#ffd9d9').attr("aria-invalid", "true");
		$('.ErrorMsgPanel > ul').append('<li><a href="#email" role="link" tabindex="0">Please enter a valid Email Address</a></li>');
		$('.ErrorMsgPanel').show();
		$('.ErrorMsgPanel > ul > li:first-child').find('a').focus();
		isFormValid = false;
	} else if (email === "") {
		$('#email').css("backgroundColor", '#ffd9d9').attr("aria-invalid", "true");
		$('.ErrorMsgPanel > ul').append('<li><a href="#email" role="link" tabindex="0">Please enter an Email Address</a></li>');
		$('.ErrorMsgPanel').show();
		$('.ErrorMsgPanel > ul > li:first-child').find('a').focus();
		isFormValid = false;
	} else {
		$('#email').css("backgroundColor", '#ffffff');
	}
	if (questions === "") {
		$('#questions').css("backgroundColor", '#ffd9d9').attr("aria-invalid", "true");
		$('.ErrorMsgPanel > ul').append('<li><a href="#questions" role="link" tabindex="0">Please include Question/Comments</a></li>');
		$('.ErrorMsgPanel').show();
		$('.ErrorMsgPanel > ul > li:first-child').find('a').focus();
		isFormValid = false;
	} else {
		$('#questions').css("backgroundColor", '#ffffff').attr("aria-invalid", "false");
	}
	if (!isFormValid) { return isFormValid; } else { $('.ErrorMsgPanel').hide(); }
	var data = { from: email, questions: questions , catalogAlias: catAlias, emailUS: true };
	
	if($(this).hasClass('emailYourself')){ 	data = { from: email, catalogAlias: catAlias, questions: questions , emailUS: false };	}
		
	$.ajax({
		url: '/layout/submitquestions',
		type: "POST",
		datatype: 'json',
		contentType: "application/json",
		data: JSON.stringify(data),
		success: function (result) {
			if (result.success == 'true') {
				if(triggerElement.hasClass('emailYourself')){
					$('.ErrorMsgPanel').after('<div class="emailSent paddingTop15" role="status"><h3 class="text16 paddingBtm10 textBlue">Thank you!</h3><p>Your email has been sent to ' + email +'</p></div>');
				} else {
					$('.ErrorMsgPanel').after('<div class="emailSent paddingTop15" role="status"><h3 class="text16 paddingBtm10 textBlue">Thank you!</h3><p>Your email has been received. One of our customer service representatives will respond shortly.</p></div>');
				}
				$('#email').val('');
				$('#questions').val('');
				$('.cancelEmail').focus();
			} else {
				$('.ErrorMsgPanel > ul').html('').append('<li role="status">Please try again later.</li>');
				$('.ErrorMsgPanel').show();
			}
		},
		error: function () {
			$('.ErrorMsgPanel > ul').html('').append('<li role="status">Please try again later.</li>');
			$('.ErrorMsgPanel').show();
		}
	});
  });
	
  //CANCEL EMAIL
  var cancelEmail = function () {
	$('#emailPopout').hide('slow', function () {
		$('#emailPopout').detach();
		$('.openEmail').removeClass('bkgdLtGray disabled').addClass('bkgdMdGray');
		$('.openEmail').after('<span class="visually-hidden"  role="status">Your email request has been cancelled</span>');
	});
  }
  //Close email popout  
  $('.contactPanel').on('click', '.cancelEmail', function(){
	cancelEmail();
  });
  //Close email popout  	
  $('.contactPanel').on('keypress', '.cancelEmail', function(e){
	if(e.which == 13){
		$(this).click();
 	}
  }); //End Email handler

//OPEN CHAT
  var openChat =  document.getElementsByClassName('openChat');
  if(openChat.length > 0){
    openChat[0].addEventListener('click', function(){
     if($(this).hasClass('disabled')){
   	 return false;
     }
     //log click event
     moduleEvents().Omniture().ChatBtnClick(); 
     openChat[0].classList.remove('bkgdMdGray');
     openChat[0].classList.add('disabled', 'bkgdLtGray');
     $(this).after('<div class="spinner" role="alert" aria-busy="true" aria-label="Loading, please wait while we load chat window"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>');
     enableChatComponents();
   });
  }
  //keypress handler
  if(openChat.length > 0){
    openChat[0].addEventListener('keypress', function(e){
   	if(e.which == 13){
		this.click();
 	}
     });
  }
  //Create chat window
  var createChatFrame = function() {
    var iframe = document.createElement('iframe');
      setAttributes(iframe, {
        "id": "chat-iframe",
        "src": "https://cicusweb2.4imprint.com/i3root/examples/EmbeddedWithinOtherPage/chatorcallback.html",
        "scrolling": "no",
         "height" : "600px",
         "width" : "500px",
         "title": "4imprint Web Chat",
         "name": "4imprint Web Chat",
      });     
    return iframe;
  }

  var setAttributes = function(el, attrs) {
    for (var key in attrs) {
      el.setAttribute(key, attrs[key]);
    }
  }

  //loading chat components takes about 4 seconds. Delay toggle to avoid showing a blank window
  var enableChatComponents = function(){
    var iframe = document.getElementById('chat-wrapper');
    $('.contactPanel').find('.spinner').detach();
    $(iframe).toggle('slow');
  };

  //Has ajax, omniture event handlers 
  var moduleEvents = function(){
    var omniture = function () {   
	  var chatBtnClick = function () {
	    var account = s_account ? s_account : "4imprintprod";	
	    var s = s_gi(account);
	    if (typeof s != "undefined") {
	      s.linkTrackVars = 'prop28';
             s.linkTrackEvents = 'None';
	      s.prop28 = 'Chat Sessions Log'; //Chat traffic, log click event
	      s.tl(true, 'o', 'Chat Sessions');
           }
         }
         
	return {
         ChatBtnClick: chatBtnClick
	}
   }; 
   	
    var getEmailForm = function() {
      return $.ajax({
      	  type: "POST",
         url: '/layout/emailus',
         dataType: "html",
         timeout: 15000,
         async: true
       });
    }
    
    var isOfficeOpen = function() {
       return $.ajax({
         type: "POST",
         url: "/Header/IsOfficeOpen",
         dataType: "json",
         timeout: 15000,
         async: true
       });
     }
  	
     var initChat =  function () {
       return $.ajax({
         url: "https://cicusweb2.4imprint.com/i3root/examples/EmbeddedWithinOtherPage/chatorcallback.html?chatUsername=TEST_IGNORE",
         type: "GET",
         dataType: "html",
         timeout: 15000,
         async: true       
       });  	
    }
    
    var getChatCSSBundle = function() {
      return $.ajax({
      	  type: "POST",
         url: '/layout/getchatcssbundle',
         dataType: "html",
         timeout: 15000,
         async: true
       });
    }
    
    return {
	Omniture: omniture,
	GetEmailForm: getEmailForm,
	InitChat : initChat,
	GetChatCSSBundle: getChatCSSBundle,
	IsOfficeOpen: isOfficeOpen
    }
  }
  
  //initialize chat
  initChat();
});